/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Fcbody1Inputs */

const zh_landing_admin_fcbody1 = /** @type {(inputs: Landing_Admin_Fcbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动生成的闪卡聚焦关键概念和定义，并会根据学生薄弱环节进行调整。StudyOS 借助间隔重复和针对性回忆，让学习更高效，而非更漫长。`)
};

const en_landing_admin_fcbody1 = /** @type {(inputs: Landing_Admin_Fcbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically generated flashcards focus on key concepts and definitions — then adapt based on what students struggle with. StudyOS helps learners review smarter, not longer, using spaced repetition and targeted recall.`)
};

const es_landing_admin_fcbody1 = /** @type {(inputs: Landing_Admin_Fcbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las tarjetas generadas automáticamente se centran en conceptos y definiciones clave, y se adaptan a lo que cuesta más a cada estudiante. StudyOS ayuda a repasar de forma más eficaz, no más larga, usando repetición espaciada y recuerdo dirigido.`)
};

/**
* | output |
* | --- |
* | "Automatically generated flashcards focus on key concepts and definitions — then adapt based on what students struggle with. StudyOS helps learners review sma..." |
*
* @param {Landing_Admin_Fcbody1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_fcbody1 = /** @type {((inputs?: Landing_Admin_Fcbody1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Fcbody1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_fcbody1(inputs)
	if (locale === "en") return en_landing_admin_fcbody1(inputs)
	return es_landing_admin_fcbody1(inputs)
});
export { landing_admin_fcbody1 as "landing_admin_fcBody" }